import { getBetPosition } from '../../../services/auction/getBetPosition';
import { getBetPositionParams } from './utils';
import { selectIsAuctionEnabled } from '../../../selectors/auction';
import { selectBetPositionClientError } from '../../../selectors/betPosition';
import { selectGeoChildLocation, selectOfferCoordinatesWithFallback } from '../../../selectors/offer';
import { IAppState } from '../../../../AppModulesWrapper';
import { loadBetPositionFail, loadBetPositionStart, loadBetPositionSuccess } from '../../../actions/betPosition';
import { TThunkAction } from '../../../../common/types/thunk';
import { selectCurrentBet, selectServiceIds } from '../../../reducers/v2/promotion/selectors';
import { sleep } from '../../../../common/utils/sleep';

export function loadBetPosition(isInstant: boolean = false): TThunkAction<Promise<void>> {
  return async function (dispatch, getState, { httpApi, logger }) {
    const state: IAppState = getState();

    logger.debug('loadBetPosition', { offer: JSON.stringify(state.servicePickerWidget.offer) });

    const serviceIds = selectServiceIds(state);
    const clientError = selectBetPositionClientError(state);
    const childLocation = selectGeoChildLocation(state);
    const coordinates = selectOfferCoordinatesWithFallback(state);
    const currentBet = selectCurrentBet(state);
    const isAuctionEnabled = selectIsAuctionEnabled(state);

    if (clientError) {
      return;
    }

    const { offer } = state.servicePickerWidget;

    const parameters = getBetPositionParams({
      offer,
      serviceIds,
      childLocation,
      coordinates,
      currentBet,
      isAuctionEnabled,
    });

    dispatch(loadBetPositionStart());

    const response = await getBetPosition({ httpApi, logger, parameters });

    const delay = isInstant ? 0 : 1000;

    // При быстром ответе сервера лоадер появляется на долю секунд в компоненте позиции, из-за чего происходит мерцание.
    // Для хорошего UX ограничиваем минимально возможное выполнение запроса
    await sleep(delay);

    if (response.success) {
      dispatch(loadBetPositionSuccess(response.payload));
    } else {
      dispatch(loadBetPositionFail());
    }
  };
}
